import HttpRequest from "../http_request";

class AddressApi extends HttpRequest {
  apiGetAddress(data) {
    let dataParams = {
      search: data.search ? data.search : null,
      page: data.page
    };
    return this.fetch(`/client/v1/pickup-points`, dataParams);
  }
  apiGetPickupPointConfigs(data) {
    return this.fetch(`/client/v1/pickup-point-configs`);
  }
  apiCreatesaveAddress(data) {
    return this.create(`/client/v1/pickup-points`, data);
  }
  apiEditAddress(data) {
    return this.edit(`/client/v1/pickup-points/${data.id}`, data);
  }
  apiEditpickupPointConfigs(data) {
    return this.edit(`/client/v1/pickup-point-configs`, data);
  }
  apiDeleteAddress(id) {
    return this.delete(`/client/v1/pickup-points/${id}`);
  }
}

export default AddressApi;
